import React from 'react'
import './DisplayOrder.css'

const DisplayOrder = (props) => {
    const {order} = props
    console.log(order);
    let items = 0;
    let sum = 0;
  return (
    <div className='orderContainer'>
       { order.map(x => 
        <>
            <div className="orderCard">
                <p className='nameOfItem'>{x[0]}</p>
                <p className='numberOfItems'>{x[1][0]}</p>
                <p>&#8377;{x[1][1]}</p>
            </div>
            <div className="noDisplay" style={{'display': "none"}}>
                {items += x[1][0]}  
                {sum += x[1][1]}
            </div>
        </>
       )}
      <div className="total">
        <p>Items : {items}</p>
        <p>Amount : &#8377;{sum}</p>
      </div>
    </div>
  )
}

export default DisplayOrder